import React from 'react'
import ContactForm from "../components/ContactForm"
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

function ContactUsPage() {
  return (
    <div>
    <Navbar/>

        <ContactForm/>
  
    </div>
  )
}

export default ContactUsPage